import React from "react";

// Filtro compacto (select nativo: rápido e acessível no celular).
export default function Seletor({ rotulo, valor, opcoes, onMudar, e2e }) {
  return (
    <label className="flex items-center gap-1.5 rounded-lg border bg-card pl-2.5 pr-1 py-1 text-xs" data-e2e={e2e}>
      <span className="text-muted-foreground">{rotulo}</span>
      <select value={valor || ""} onChange={(e) => onMudar(e.target.value)} className="bg-transparent font-semibold outline-none py-0.5 max-w-[11rem]">
        <option value="">Todos</option>
        {(opcoes || []).map((o) => <option key={o.id} value={o.id}>{o.rotulo}</option>)}
      </select>
    </label>
  );
}
